module.exports = __webpack_public_path__ + "static/media/cross-add-icon.ba680361.svg";